/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { SystemInfoPage } from '@/pages/SystemInfo/SystemInfoPage';

export function SystemInfoRoute() {
  return <SystemInfoPage />;
}
